import { render, staticRenderFns } from "./consultar-extrato.vue?vue&type=template&id=dafa84fe&"
import script from "./consultar-extrato.vue?vue&type=script&lang=ts&"
export * from "./consultar-extrato.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports